<template>
  <b-row>
    <b-col
        md="2"
        sm="4"
        class="my-1"
    >

      <b-form-group
          class="mb-0"
      >
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            :options="pageOptions"
            class="w-50"
        />
      </b-form-group>
    </b-col>
    <b-col
        md="2"
        sm="4"
        class="my-1"
    >

      <b-form-group
          class="mb-0"
      >
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select
            v-model="voucherOption"
            size="sm"
            :options="voucherOptions"
            class="w-50"
        />
      </b-form-group>
    </b-col>
    <b-col
        md="2"
        sm="8"
        class="my-1"
    >
      <b-form-group
          label="Datum"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="sortBySelect"
          class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
              ref="fieldData"
              v-model="date.from"
              type="text"
              placeholder="DD.MM.YY"
              autocomplete="off"
              show-decade-nav
              @keypress="EnterDate($event)"
          />
          <b-input-group-append>
            <b-form-datepicker
                :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                button-only
                :start-weekday="1"
                locale="de-DE"
                color="danger"
                size="sm"
                @context="onDateFromContext"
            />
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
        md="2"
        sm="8"
        class="my-1"
    >
      <b-form-group
          class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
              ref="fieldData"
              v-model="date.to"
              type="text"
              placeholder="DD.MM.YY"
              autocomplete="off"
              show-decade-nav
              @keypress="EnterDate($event)"
          />
          <b-input-group-append>
            <b-form-datepicker
                :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                button-only
                :start-weekday="1"
                locale="de-DE"
                color="danger"
                size="sm"
                @context="onDateToContext"
            />
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
        md="2"
        class="my-1"
    >
      <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Name, Telefon etc."
          />
          <b-input-group-append>
            <b-button
                :disabled="!filter"
                @click="filter = ''"
            >
              Leeren
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
        md="2"
        class="my-1"
    >
      <b-form-group
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
      >
        <b-input-group size="sm">
          <b-dropdown
              class="btn-block"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="info"
              text="Neuer Voucher"
              right
          >
            <b-dropdown-item
                variant="info"
                @click="CreateVoucher(99)"
            >Crew
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item
                variant="info"
                @click="CreateVoucher(0)"
            >Flughafentransfer
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item
                variant="danger"
                @click="CreateVoucher(1)"
            >Krankenfahrt
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item
                variant="warning"
                @click="CreateVoucher(2)"
            >Mietwagenfahrt
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item
                variant="dark"
                @click="CreateVoucher(88)"
            >Letzte eingabe
            </b-dropdown-item>
          </b-dropdown>

        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-table
          striped
          hover
          responsive
          :items="items"
          :fields="fields"
          @filtered="onFiltered"
          @row-clicked="clickVoucher"
      >
        <template #cell(Drivers)="data">
        </template>
        <template #cell(Vid)="data">{{ data.item.Vid }}
          <feather-icon
              v-show="data.item.BillNumber != ''"
              icon="LockIcon"
              size="12"
          />
          <b-badge
              v-show="data.item.Canceled != null"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.v-primary
              :title="(data.item.Canceled + ' ('+data.item.CanceledUser+')')"
              variant="warning"
          >Storniert
          </b-badge>
        </template>
        <template #cell(Price)="data">
          <b-badge
              variant="light-info"
          >{{data.item.NetSum}}
          </b-badge>
        </template>
        <template #cell(Info)="data">
          <connected-voucher-badge v-bind:vData="data.item.ConnectedVoucher" />
        </template>
      </b-table>
    </b-col>

    <b-col
        cols="12"
    >
      <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BAlert, VBTooltip, BFormDatepicker,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ConnectedVoucherBadge from '@/views/extras/ConnectedVoucherBadge.vue'

export default {
  components: {
    ConnectedVoucherBadge,
    BTable,
    BAvatar,
    BAlert,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BFormDatepicker,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      perPage: 50,
      pageOptions: [10, 25, 50, 100, 250, 500],
      voucherOption: 0,
      voucherOptions: [{
        text: "",
        value: 0
      },
        {
          text: "Stornos anzeiegn",
          value: 1
        }],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      date: {
        from: '',
        to: ''
      },
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'Vid',
          label: 'V-Data',
        },
        {
          key: 'PickupTime',
          label: 'Abholung',
        },
        {
          key: 'Passengers',
          label: 'Personen',
        },
        {
          key: 'Customer',
          label: 'Kunde',
        },
        {
          key: 'PickUpAddress',
          label: 'Adresse',
        },
        {
          key: 'DestinationAddress',
          label: 'Ziel',
        },
        {
          key: 'Price',
          label: 'Preis',
        },
        {
          key: 'Info',
          label: 'Info',
        },
      ],
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },

  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Voucherliste'
    })
    this.LoadList()

    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.voucherOption,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList(0)
          }, 550)
        },
    )
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {

    EnterDate(event) {
      if (event.which == 13) {
        this.LoadList()
      }
    },
    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.from = ctx.activeFormatted
        this.LoadList()
      }
    },
    onDateToContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.to = ctx.activeFormatted
        this.value = ctx.activeFormatted
        this.LoadList()
      }
    },
    clickVoucher(record, index) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: record.Vid }
      })
    },
    CreateVoucher(t) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: 0, type: t }
      })
    },
    LoadList() {
      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/voucher/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url += `&filter=${this.filter}`
      }
      if (this.date.from != '') {
        const date = this.date.from.split('.')
        if (this.date.from.length == 8) {
          url += `&fromDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      if (this.date.to != '') {
        const date = this.date.to.split('.')
        if (this.date.to.length == 8) {
          url += `&toDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      if (this.voucherOption != 0) {
        url += `&voucherOption=${this.voucherOption}`
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {

              this.items.push(i)
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
